import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Dispatch } from '../../redux/store';

const AttachmentsHelper = function AttachmentsHelper(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();

  const messages = [
    { id: 'printquote', defaultMessage: 'Quote/Invoice PDF' },
    { id: 'cutsheet', defaultMessage: 'Cut Sheet' },
    { id: 'specsheet', defaultMessage: 'Spec Sheet' },
    { id: 'others', defaultMessage: 'Others' }
  ];

  return (
    <>
      <Typography>
        <FormattedMessage
          id='youcanfindthefollowinghere'
          defaultMessage='You can find the following here:'
        />
      </Typography>
      <ul>
        {messages.map(m => (
          <li key={m.id}>
            <Typography>
              <FormattedMessage id={m.id} defaultMessage={m.defaultMessage} />
            </Typography>
          </li>
        ))}
      </ul>

      <Button
        variant='outlined'
        color='inherit'
        onClick={dispatch.attachmentsMenu.hideTooltipPopup}
        fullWidth
      >
        <FormattedMessage
          id='dontshowmethisagain'
          defaultMessage="Don't show me this again"
        />
      </Button>
    </>
  );
};

export default AttachmentsHelper;
